const parseMoqMultiplier = (moqMultiplier?: number | string | null) => {
  const parsed = Number(moqMultiplier)
  return Number.isFinite(parsed) ? parsed : Number.NaN
}

export const resolveMoqMultiplierEnabled = (moqMultiplier?: number | string | null) => {
  const parsed = parseMoqMultiplier(moqMultiplier)
  if (!Number.isFinite(parsed)) return false
  return parsed > 1
}

export const isMoqMultiplierToggleDisabled = (
  moqMax: boolean,
  moqMultiplier?: number | string | null,
) => {
  if (!moqMax) return false
  return resolveMoqMultiplierEnabled(moqMultiplier)
}

export const normalizeLoadedMoqMultiplier = (
  moqMax: boolean,
  moqMultiplier?: number | string | null,
): number => {
  if (moqMax) {
    const parsed = parseMoqMultiplier(moqMultiplier)
    if (!Number.isFinite(parsed) || parsed <= 1) return 1
    return parsed
  }
  if (resolveMoqMultiplierEnabled(moqMultiplier)) {
    const parsed = parseMoqMultiplier(moqMultiplier)
    return Number.isFinite(parsed) ? parsed : 1
  }
  return 1
}

export const resolveMoqMultiplierDisplayValue = (
  isEnabled: boolean,
  moqMultiplier?: number | string | null,
  moqMax = false,
): string => {
  if (isEnabled) {
    const parsed = parseMoqMultiplier(moqMultiplier)
    if (Number.isFinite(parsed) && parsed === 0) return ''
    return String(moqMultiplier ?? '')
  }
  return String(normalizeLoadedMoqMultiplier(moqMax, moqMultiplier))
}

export const resolveMoqMultiplierSubmitValue = (moqMultiplier?: number | string | null) => {
  const parsed = parseMoqMultiplier(moqMultiplier)
  if (Number.isFinite(parsed) && parsed > 1) return parsed
  return 1
}

export const resolveMoqMultiplierForVendor = (
  moqMax: boolean,
  moqMultiplier?: number | string | null,
) => {
  if (moqMax) return normalizeLoadedMoqMultiplier(true, moqMultiplier)
  return resolveMoqMultiplierSubmitValue(moqMultiplier)
}

export const resolveNextMoqMultiplierEnabled = (
  locked: boolean,
  moqMultiplier: number | string | null | undefined,
  currentEnabled: boolean,
) => {
  if (locked) return resolveMoqMultiplierEnabled(moqMultiplier)
  if (currentEnabled) return true
  return resolveMoqMultiplierEnabled(moqMultiplier)
}

export const normalizeMoqMultiplierForForm = (
  moqMax: boolean,
  moqMultiplier?: number | string | null,
) => {
  const formValue = normalizeLoadedMoqMultiplier(moqMax, moqMultiplier)
  const enabled = resolveMoqMultiplierEnabled(moqMultiplier)
  return { enabled, formValue }
}
